import fetch from "@/uilts/request";


// 深圳风控报告
export default {

      async createCreditfs(data) {
        return await fetch.post("FsZhengXin/createCreditfs", data)
    },
    /**
     * 创建授权书
     */
    async sjxTestGenOpen(data) {
        return await fetch.post("FsZhengXin/sjxTestGenOpen", data)
    },
    /**
     * 获取风控结果
     */

    async sjxTestGen(data){
        return await fetch.post("FsZhengXin/sjxTestGen", data)
    },

    async sjxGetGetResult(data){
        return await fetch.post("FsZhengXin/sjxGetGetResult", data)
    }
}